export const PERMISSIONS_MANAGEMENT_GET_ALL_ROLES = 'PERMISSIONS_MANAGEMENT_GET_ALL_ROLES'
export const PERMISSIONS_MANAGEMENT_UPDATE_ROLE_PERMISSIONS = 'PERMISSIONS_MANAGEMENT_UPDATE_ROLE_PERMISSIONS'
export const PERMISSIONS_MANAGEMENT_GET_USER_ROLES = 'PERMISSIONS_MANAGEMENT_GET_USER_ROLES'
export const PERMISSIONS_MANAGEMENT_HIDE_MODAL = 'PERMISSIONS_MANAGEMENT_HIDE_MODAL'
export const PERMISSIONS_MANAGEMENT_SHOW_MODAL = 'PERMISSIONS_MANAGEMENT_SHOW_MODAL'
